<script setup lang="ts">
import { toRefs } from "vue";
import { utc2local } from "@/utils";
import type { PromotionCodeLogEntry } from "@/rvapi";

const props = defineProps<{
  codes: PromotionCodeLogEntry[];
  searching: boolean;
}>();

const { codes, searching } = toRefs(props);
</script>

<template>
  <section v-show="!searching && codes.length > 0">
    <h3>Promotion code creation log</h3>
    <p>
      If a code is still active, it will also show up under "Active promotion
      codes".
    </p>
    <p>
      If a code has been used, it will also show up under "Orders with promotion
      code".
    </p>
    <p>Otherwise, the code has expired.</p>
    <pn-table bordered="true" striped="true">
      <table>
        <thead>
          <tr>
            <th>Code</th>
            <th>Value</th>
            <th>Limit</th>
            <th>Expires</th>
            <th>Login required</th>
            <th>Batch label</th>
            <th>Created by</th>
            <th>Created</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="p in codes" :key="p.code">
            <td>{{ p.code }}</td>
            <td>{{ p.data.value }}</td>
            <td>{{ p.data.usageLimit }}</td>
            <td>{{ utc2local(p.data.expireAt) }}</td>
            <td>{{ p.data.requireLogin ?? "false" }}</td>
            <td>{{ p.data.campaign ?? "" }}</td>
            <td>{{ p.createdBy }}</td>
            <td>{{ utc2local(p.createdAt) }}</td>
          </tr>
        </tbody>
      </table>
    </pn-table>
  </section>
</template>
<style lang="scss" scoped></style>
